import React from 'react';
import { MATERIAL_HIGHLIGHT_COLOR } from '../../../constants/globals';

export const Resources = () => ( 
  <resources>
    <meshBasicMaterial
      resourceId="highlightMaterial"
      color={MATERIAL_HIGHLIGHT_COLOR}
      wireframe
    />
    <meshBasicMaterial
      resourceId="warningMaterial"
      color="red"
      wireframe
      transparent={false}
      wireframeLinewidth={200}
    />
  </resources>
);

export default Resources;



// WEBPACK FOOTER //
// ./src/components/common/materials/Resources.js